import { ApartmentOutlined } from '@ant-design/icons';
import { Collapse, Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import ProfilePicture from '../../../../../../../components/ProfilePicture';
import { Organization } from '../../../../../../../model/types';
import CustomOrganizationFieldsContainer from './CustomOrganizationFormFieldsContainer';
import OrganizationInfoContainer from './OrganizationInfoContainer';

const { Panel } = Collapse;
const { Text } = Typography;

export default function ShowOrganizationFieldsContainer({ organizationData }: { organizationData: Organization }) {
    const { t } = useTranslation('forms');
    const { t: tPeople } = useTranslation('people');
    return (
        <Collapse defaultActiveKey={['1', '2']} ghost expandIconPosition="end">
            <Panel
                header={
                    <Space size="large">
                        <ProfilePicture icon={<ApartmentOutlined />} />
                        <Space direction="vertical" size={0}>
                            <Text strong>{organizationData?.name ?? '-'}</Text>
                            <Text type="secondary" style={{ fontSize: 10 }}>
                                {tPeople('requesterView.info')}
                            </Text>
                        </Space>
                    </Space>
                }
                key="1"
            >
                <OrganizationInfoContainer organizationData={organizationData} />
            </Panel>
            <Panel
                header={
                    <Space size="large">
                        <Text strong>{t('OrganizationFields')}</Text>
                    </Space>
                }
                key="2"
            >
                <CustomOrganizationFieldsContainer isActive={false} />
            </Panel>
        </Collapse>
    );
}
